import { setVersionInfo } from "@buzzeasy/shared-frontend-utilities";
import ReactDOM from "react-dom/client";
import environmentConfig from "../../environmentConfig";
import globalSetup from "../../globalSetup";
import App from "./App";

import "@buzzeasy/shared-frontend-utilities/extensions";

setVersionInfo("agent-ui-host", environmentConfig.buildNumber);
globalSetup();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
